// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getByPath = (obj: Record<string, any>, path: string) => {
    return path.split('.').reduce((acumulador, clave) => {
        return acumulador && acumulador[clave] !== undefined
            ? acumulador[clave]
            : undefined;
    }, obj);
};
